module.exports = "<div class=\"graph-content\">\n    <div class=\"graph-current\" ng-if=\"$ctrl.graphTitle\">{{$ctrl.graphTitle}}</div>\n    <div class=\"graph-graph\" ng-class=\"{'no-title-height': !$ctrl.graphTitle}\" ctx-resize=\"$ctrl.resizeHandler()\">\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxGraph/ctxGraph.template.html
// module id = 190
// module chunks = 0 1